import { AnalyticsService } from '@alison/analytics/client';
import { TrackingProvider } from '@alison/ui';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { TourProvider } from '../components/tour/TourProvider.js';
import { AlisonRunData } from '../components/workflows/alison-run/AlisonRunData.js';
import { AlisonRunLayer } from '../components/workflows/alison-run/ui/AlisonRunLayer.js';
import { AnalyticsBootstrap } from '../lib/AnalyticsBootstrap.js';
import { useOnboardingGate } from '../lib/onboardingGate.js';

function RootComponent(): ReactNode {
  const redirecting = useOnboardingGate();
  return (
    <TrackingProvider track={(event, properties) => AnalyticsService.track(event, properties)}>
      <AnalyticsBootstrap />
      <TourProvider>
        <AlisonRunData>
          {redirecting ? null : <Outlet />}
          <AlisonRunLayer />
        </AlisonRunData>
      </TourProvider>
    </TrackingProvider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
